import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import Waypoint from 'react-waypoint'
import Cookies from 'js-cookie'
import axios from 'axios'

import { Image } from '../utils/lazyImage'

import HeaderSpacer from '../global/header-spacer'
import ExcerptList from './excerptList'
import PostExcerpt from './excerpt'
import ShareButtons from '../social/social'
import Navigation from '../navigation'

import globalState from '../../helpers/globalState'
import buildLink from '../../helpers/linkBuilder'
import { translate } from '../../helpers/stringTranslation'

import Styles from '../../styles/components/post.module.scss'
const {
  postTileLarge,
  postDateLarge,
  postCategoriesLarge,
  postSingleDetails,
  postSingleContent,
  postSingleArchives,
  postSingleContainer,
  postSingleLayout,
  postSingleArchiveTitle,
  postSingleArchiveList,
  postSingleArchiveItem,
  postSingleSeeMore,
  postSingleItem_text,
} = Styles

function intersperse(arr, sep) {
  if (arr.length === 0) {
    return []
  }

  return arr.slice(1).reduce(
    function(xs, x, i) {
      return xs.concat([sep, x])
    },
    [arr[0]]
  )
}

class FixedSocial extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      fixedSocial: false,
      left: 0,
      show: false,
    }
    this.ref = null

    this.socialPositionChanged = this.socialPositionChanged.bind(this)
    this.setRef = this.setRef.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onLoad = this.onLoad.bind(this)
  }
  socialPositionChanged(e) {
    const fixedSocial = e.currentPosition === 'below'
    if (fixedSocial !== this.state.fixedSocial) {
      this.setState(state => ({
        ...state,
        fixedSocial,
      }))
    }
  }

  onResize() {
    const bbox = this.ref.getBoundingClientRect()
    const left = bbox.left
    if (left !== this.state.left) {
      this.setState(state => ({
        ...state,
        left,
      }))
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('load', this.onLoad)
    if (document.readyState === 'complete') {
      this.onLoad()
    } else {
      this.onResize()
    }
  }

  componentWillUnmount() {
    this.ref = null
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('load', this.onLoad)
  }

  setRef(ref) {
    this.ref = ref
  }

  onLoad() {
    this.setState(state => ({ ...state, show: true }))
    this.onResize()
  }

  render() {
    const { fixedSocial, left, show } = this.state

    let style = {}

    if (fixedSocial) {
      style = {
        position: 'fixed',
        left,
        bottom: 20,
      }
    }

    return (
      <div className={Styles.postSingleSocial}>
        <div ref={this.setRef}>
          {(show || !fixedSocial) && (
            <div style={style}>
              <ShareButtons url={this.props.url} />
            </div>
          )}
        </div>
        <div className={Styles.postSingleSocialBreakPoint}>
          <Waypoint onPositionChange={this.socialPositionChanged} />
        </div>
      </div>
    )
  }
}

class ArhiveList extends React.PureComponent {
  constructor(props) {
    super(props)

    this.toggleExpand = this.toggleExpand.bind(this)
    this.state = {
      expanded: false,
    }
  }

  toggleExpand() {
    this.setState(state => ({
      ...state,
      expanded: !state.expanded,
    }))
  }

  render() {
    const { label, items, forceExpanded = false } = this.props
    const { expanded } = this.state

    const treshhold = 3
    const renderShowMore = !forceExpanded && items.length > treshhold + 1
    const renderItems = expanded || !renderShowMore ? items : items.slice(0, 3)

    return (
      <React.Fragment>
        <h3 className={postSingleArchiveTitle}>{label}</h3>
        <ul className={postSingleArchiveList}>
          {items.map((item, index) => (
            <li
              className={
                expanded || !renderShowMore || index < treshhold
                  ? Styles.postSingleArchiveItemVisible
                  : Styles.postSingleArchiveItemHidden
              }
              key={item.slug}
            >
              <Link to={item.link}>
                {item.label} ({item.count})
              </Link>
            </li>
          ))}
          {renderShowMore && (
            <li className={Styles.postSingleArchiveItemShowMoreOrLess}>
              <span
                onClick={this.toggleExpand}
                className={Styles.postSingleArchiveItemMoreOrLess}
              >
                {translate(expanded ? 'showless' : 'showmore')}
              </span>
            </li>
          )}
        </ul>
      </React.Fragment>
    )
  }
}

class SinglePost extends React.PureComponent {
  constructor(props) {
    super(props)

    const article = props.data.article

    this.article = {
      ...article,
      url: buildLink({
        type: 'post',
        lang: article.lang,
        slug: article.slug,
        absolute: true,
      }),
      categories: article.categories.map(cat =>
        globalState.state.articleCategories.find(gcat => gcat.slug === cat.slug)
      ),
    }

    this.monthlyArchives = this.props.data.monthlyArchives
      ? this.props.data.monthlyArchives.edges
          .map(edge => ({
            ...edge.node,
            label: `${translate('months')[edge.node.month - 1]} ${
              edge.node.year
            }`,
          }))
          .sort((a, b) => {
            const year_a = parseInt(a.year)
            const year_b = parseInt(b.year)

            return -(year_a !== year_b ? year_a - year_b : a.month - b.month)
          })
      : []

    // this.monthlyArchives = [
    //   ...this.monthlyArchives,
    //   ...this.monthlyArchives,
    //   ...this.monthlyArchives,
    //   ...this.monthlyArchives,
    //   ...this.monthlyArchives,
    //   ...this.monthlyArchives,
    // ]
    this.hasRead = this.hasRead.bind(this)

    this.id = this.props.data.article.wordpress_id
  }

  readCookie() {
    this.reportedRead = false
    const cookie = Cookies.get('readStatus')

    if (cookie) {
      const c = JSON.parse(cookie)
      if (typeof c === 'object') {
        this.readStatus = c
        this.reportedRead = !!this.readStatus[this.id]
        return
      }
    }
    this.readStatus = {}
  }

  componentDidMount() {
    this.readCookie()
  }

  hasRead() {
    if (!this.reportedRead) {
      const url = `http://admin.brandglow.pl/wp-admin/admin-ajax.php`

      axios
        .get(url, {
          params: {
            action: 'has_read',
            id: this.id,
          },
        })
        .then(response => response.data)
        .then(data => {
          if (data.success) {
            this.reportedRead = true
            this.readStatus[this.id] = 1
            Cookies.set('readStatus', this.readStatus)
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  }

  renderItem(item, index) {
    let elem = null,
      type = null

    if (item.__typename === 'WordPressAcf_post_layout_text' && item.text) {
      type = 'text'
      elem = (
        <div
          className="styled-content"
          dangerouslySetInnerHTML={{
            __html: item.text,
          }}
        />
      )
    } else if (
      item.__typename === 'WordPressAcf_post_layout_image' &&
      item.respImage
      // item.image.localFile.childImageSharp
    ) {
      type = 'image'
      elem = <Image sizes={item.respImage} />
    }

    return elem ? (
      <div className={Styles[`postSingleItem_${type}`]} key={`item_${index}`}>
        {elem}
      </div>
    ) : null
  }

  render() {
    const { article } = this

    return (
      <div>
        {/* <HeaderSpacer /> */}

        <div className={postSingleContainer}>
          {article.respFeaturedImage && (
            <Image sizes={article.respFeaturedImage} />
          )}
          <div className={postSingleLayout}>
            <div className={postSingleDetails}>
              <h1
                className={postTileLarge}
                dangerouslySetInnerHTML={{
                  __html: article.title,
                }}
              />
              <div className={postDateLarge}>{article.formattedDate}</div>
              <div className={postCategoriesLarge}>
                {translate('category')}:{' '}
                {intersperse(
                  article.categories.map(category => (
                    <Link key={category.label} to={category.link}>
                      {category.label}
                    </Link>
                  )),
                  ', '
                )}
              </div>
            </div>
            <div className={postSingleContent}>
              {article.acf.post_layout_post &&
                article.acf.post_layout_post.map(this.renderItem)}

              <Waypoint onEnter={this.hasRead} />
            </div>

            <div className={postSingleArchives}>
              <ArhiveList
                label={translate('categories')}
                forceExpanded={true}
                items={globalState.state.articleCategories.filter(
                  category => category.lang === this.props.lang
                )}
              />
              {this.monthlyArchives.length > 0 && (
                <ArhiveList
                  label={translate('archive')}
                  items={this.monthlyArchives}
                />
              )}
            </div>
          </div>
          <FixedSocial url={article.url} />

          {this.props.data.relatedArchives && (
            <div className={postSingleSeeMore}>Zobacz również:</div>
          )}
          {this.props.data.relatedArchives && (
            <ExcerptList>
              {this.props.data.relatedArchives.edges.map(edge => {
                return <PostExcerpt key={edge.node.slug} data={edge.node} />
              })}
            </ExcerptList>
          )}
        </div>
        <Navigation />
      </div>
    )
  }
}

export default SinglePost

export const fragment = graphql`
  fragment PostSingleFragment on wordpress__POST {
    title
    formattedDate: date(formatString: "D.M.Y")
    slug
    id
    wordpress_id
    excerpt
    categories {
      name
      slug
    }
    lang
    respFeaturedImage {
      bgColor
      aspectRatio
      src
      srcSet
      srcWebp
      srcSetWebp
      sizes
    }
    featured_media {
      title
      localFile {
        childImageSharp {
          ...SEOImageFragment
        }
      }
    }
    yoast {
      title
      metadesc
    }
    acf {
      post_layout_post {
        __typename
        ... on WordPressAcf_post_layout_text {
          text
        }
        ... on WordPressAcf_post_layout_image {
          respImage(origin: "image") {
            bgColor
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            sizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/post/single.js